import { createSelector } from '@reduxjs/toolkit';
import { EditIcon } from 'evergreen-ui';
import { dcpcApi } from './dcpcApi';
import { DATASOURCE_PROGRAM_BLOCK_INVALIDATE_TAG } from './datasourceProgramBlocksApi';
import { tags } from './tags';

const INVALIDATE_PROGRAM_TAG = 'Invalidate_program';

const {
  DELETE_PROGRAM_BLOCK_TAG,
  CREATE_PROGRAM_BLOCK_TAG,
  PROGRAM_BLOCK_TAG,
  DELETE_PROGRAM_TAG,
  PROGRAM_TAG,
  PROGRAMS_BY_DATASOURCE_TAG,
  PROGRAM_BY_DATASOURCE_TAG,
} = tags;

dcpcApi.enhanceEndpoints({ addTagTypes: [PROGRAM_TAG, INVALIDATE_PROGRAM_TAG, DELETE_PROGRAM_TAG, PROGRAMS_BY_DATASOURCE_TAG, PROGRAM_BY_DATASOURCE_TAG] });

const api = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({

    getProgram: builder.query({
      query: (id) => `devicetype/${id}/program`,
      providesTags: () => [PROGRAM_TAG],
    }),

    // TODO: переименовать, когда в базе станет все ок
    getProgram2: builder.query({
      query: (id) => `program/${id}/program`,
      providesTags: () => [PROGRAM_TAG, INVALIDATE_PROGRAM_TAG],
    }),

    getProgramBlocksByProgramId: builder.query({
      query: (id) => `program/${id}/program-blocks`,
      providesTags: [PROGRAM_TAG, DELETE_PROGRAM_BLOCK_TAG, CREATE_PROGRAM_BLOCK_TAG, PROGRAM_BLOCK_TAG],
    }),

    updateProgram: builder.mutation({
      query: (data) => ({
        url: `devicetype/program${data?.id ? `/${data?.id}` : ''}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: [PROGRAM_TAG, DATASOURCE_PROGRAM_BLOCK_INVALIDATE_TAG],
    }),

    // TODO: переименовать
    createProgram2: builder.mutation({
      query: (data) => ({
        url: 'program',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [INVALIDATE_PROGRAM_TAG],
    }),

    // TODO: переименовать
    updateProgram2: builder.mutation({
      query: (data) => ({
        method: `${data.id ? 'PUT' : 'POST'}`,
        url: `program${data.id ? `/${data.id}` : ''}`,
        body: data,
      }),
      invalidatesTags: [INVALIDATE_PROGRAM_TAG],
    }),

    getPrograms: builder.query({
      query: (params) => ({ url: 'v2/programs', params }),
      providesTags: () => [PROGRAM_TAG, INVALIDATE_PROGRAM_TAG],
    }),

    createProgram: builder.mutation({
      query: ({ params, body }) => ({
        url: 'devicetype/program/newversion/',
        params,
        method: 'POST',
        body,
      }),
      invalidatesTags: [PROGRAM_TAG],
    }),

    deleteProgramById: builder.mutation({
      query: (id) => ({
        url: `program/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [PROGRAM_TAG, DELETE_PROGRAM_TAG],
    }),

    getProgramsByDatasourceTypeId: builder.query({
      query: (id) => `program/datasource-type/${id}`,
      providesTags: [PROGRAM_TAG],
    }),

    getProgramsByDatasourceId: builder.query({
      query: (datasourceId) => `program/datasource/${datasourceId}`,
      providesTags: [PROGRAMS_BY_DATASOURCE_TAG],
    }),
    getProgramByProgramId: builder.query({
      query: ({ programId, datasourceId }) => `program/${programId}/datasource/${datasourceId}`,
      providesTags: [PROGRAM_BY_DATASOURCE_TAG],
    }),

    getProgramsByDatasourceId2: builder.query({
      query: (datasourceId) => `programs/datasources/${datasourceId}`,
    }),

    getProgramsByStationId: builder.query({
      query: (stationId) => `programs/stations/${stationId}`,
    }),
  }),
});

export const {
  useGetProgramQuery,
  useGetProgram2Query,
  useGetProgramsQuery,
  useGetProgramBlocksByProgramIdQuery,
  useDeleteProgramByIdMutation,
  useUpdateProgramMutation,
  useCreateProgramMutation,
  useCreateProgram2Mutation,
  useUpdateProgram2Mutation,
  useGetProgramsByDatasourceTypeIdQuery,
  useGetProgramsByDatasourceIdQuery,
  useGetProgramByProgramIdQuery,

  useGetProgramsByDatasourceId2Query,
  useGetProgramsByStationIdQuery,
} = api;

export const programsSelect = (state) => api.endpoints.getPrograms.select()(state);
export const programsSelector = (state) => programsSelect(state).data || [];

export const filterProgramsBySearchTextSelector = createSelector(
  programsSelector,
  (_, searchText) => searchText,
  (programs, searchText) => ({
    columns: [
      {
        label: 'Название',
      },
      {
        label: 'Дата создания',
      },
    ],
    rows: programs.reduce((acc, cur) => {
      const {
        id, name, createDate,
      } = cur;
      const row = [id, name, createDate].map((v) => v || '');
      if (row.filter((v, idx) => idx !== 0 && v !== null && v.toUpperCase().includes(searchText.toUpperCase())).length > 0) {
        acc.push(row);
      }
      return acc;
    }, []),
    rowButtons: [
      {
        label: 'Редактировать',
        to: (id) => `${id}`,
        icon: EditIcon,
      },
    ],
    createLink: {
      label: 'Создать программу наблюдения',
    },
  }),
);

export const programsBySearchTextSelector = (searchText) => (state) => filterProgramsBySearchTextSelector(state, searchText);
